<template>
    <div class="float-left mr-1">
        <i
            class="fa fa-edit fa-lg icon-button"
            title="Atualizar"
            @click.stop="abrirModal()"
        ></i>
        <prestacao-contas-final-lancamento-form
            operacaoProp="A"
            :convenio = "convenio"
            :prestacaoContasFinalLancamento="prestacaoContasFinalLancamento"
            :idPrestacaoMensal="idPrestacaoMensal"
            :mostrarModal="mostrarModal"
            :erros="erros"
            :dataServicos="dataServicos"
            @fechar="fecharModal()"
            @salvar="salvar($event)">
        </prestacao-contas-final-lancamento-form>
    </div>
</template>

<script>
    
import PrestacaoContasFinalLancamentoForm from './PrestacaoContasFinalLancamentoForm.vue'

export default {
    components: {
        PrestacaoContasFinalLancamentoForm
    },

    props: {
        convenio: Object,
        prestacaoContasFinalLancamento: Object,
        idPrestacaoMensal: Number,
        desativarBotao: Boolean,
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(prestacaoContasFinalLancamento) {
            this.$store.dispatch('addRequest')
            let prestacaoAtualizadaDto = {
                codSituacao: prestacaoContasFinalLancamento.codSituacao,
                codTipoPrestacaoContas: prestacaoContasFinalLancamento.codTipoPrestacaoContas,
                dtEmissao: this.$moment(this.prestacaoContasFinalLancamento.dtEmissao,'DD/MM/YYYY').format('YYYY-MM-DD'),
                dtPagamento: this.prestacaoContasFinalLancamento.dtPagamento != null ? this.$moment(this.prestacaoContasFinalLancamento.dtPagamento, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                idAcaoConvenio: prestacaoContasFinalLancamento.idAcaoConvenio,
                idNaturezaDespesa: prestacaoContasFinalLancamento.idNaturezaDespesa,
                idPrestacaoContasFinal: prestacaoContasFinalLancamento.idPrestacaoContasFinal,
                idPrestacaoContasMensal: this.idPrestacaoMensal,
                nuConfins: prestacaoContasFinalLancamento.nuConfins,
                nuCsll: prestacaoContasFinalLancamento.nuCsll,
                nuInss: prestacaoContasFinalLancamento.nuInss,
                nuIr: prestacaoContasFinalLancamento.nuIr,
                nuIss: prestacaoContasFinalLancamento.nuIss,
                nuPis: prestacaoContasFinalLancamento.nuPis,
                nuValor: prestacaoContasFinalLancamento.nuValor,
                situacao: prestacaoContasFinalLancamento.situacao,
                tipoPrestacaoContas: prestacaoContasFinalLancamento.tipoPrestacaoContas,
                vcDoctoPag: prestacaoContasFinalLancamento.vcDoctoPag,
                vcDocumento: prestacaoContasFinalLancamento.vcDocumento,
                vcFavorecido: prestacaoContasFinalLancamento.vcFavorecido, 
                simplesNacional: prestacaoContasFinalLancamento.simplesNacional,
                lancamentoBancario: prestacaoContasFinalLancamento.lancamentoBancario           
            }
            this.dataServicos.AtualizarPrestacaoFinal(prestacaoAtualizadaDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Lançamento atualizado com Sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.fecharModal()
                        this.$emit('atualizarLista')
                        }
                        } else {
                            this.erros = response.errors
                        }
                
                this.$store.dispatch('removeRequest')
            })
        },
    },
    
}
</script>

